import { MessageEventBus, ModelEventBus } from "../../event-bus";
import { StatechartsService } from "../services/statecharts/statecharts-service";
import { editorStateStore } from "../services/storage/editor-state-store";
import { IdentifiableDiagnostic, IValidator, ValidatorService } from "../services/validation-service";
import RappidContext from "./rappid-context";

export class Validator implements IValidator {
  constructor(
    private context: RappidContext,
    private cloudStatechartService: StatechartsService
  ) {}

  validate(service: ValidatorService) {
    editorStateStore().validationTriggered();
    const modelJson = JSON.stringify(this.context.paper.model.toJSON(), null, 2);
    this.cloudStatechartService
      .createOrUpdate(editorStateStore().getModelId, modelJson, this.context)
      .then(() => {
        service.validateModelById(editorStateStore().getModelId, this.emitValidationResult);
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .catch((err: any) => {
        let errMsg = "Model validation failed.";
        if (typeof err === "string") errMsg = err;
        MessageEventBus.emit("error", {
          text: errMsg,
          id: "trigger-validation",
        });
      });
  }

  emitValidationResult(diagnostics: IdentifiableDiagnostic[]) {
    editorStateStore().validationCompleted();
    ModelEventBus.emit("modelValidated", diagnostics);
  }
}
